module.exports = __webpack_public_path__ + "static/media/seamless-integration.caef9c0b.svg";